import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

function Layout() {
    const location = useLocation();
    const isEnjoyPage = location.pathname.includes('/enjoy');
    
    return (
        <div className={`checkout ${!isEnjoyPage ? 'hide-footer-mobile' : ''}`}>
            <Outlet />
        </div>
    );
}

export default Layout;
